/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import DOMPurify from "dompurify";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css/bundle";

// ImageVideoGallery component (Named Export)
export const ImageVideoGallery = ({ gallerydata = {}, add_content = "" }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const {
    top_video_url = "",
    bottom_video_url = "",
    top_images = [],

    bottom_images = [],
  } = gallerydata || {};

  // Fixed UI structure
  const arrangedItems = [
    // top_video_url
    //   ? { type: "video", src: top_video_url, className: "large-left" }
    //   : null,
    top_images[0]
      ? {
          type: "img",
          src: top_images[0].add_image_url,
          className: "small-top-right",
        }
      : null,
    top_images[1]
      ? {
          type: "img",
          src: top_images[1].add_image_url,
          className: "small-top-right",
        }
      : null,
    bottom_images[0]
      ? {
          type: "img",
          src: bottom_images[0].add_image_url,
          className: "small-bottom-left",
        }
      : null,
    bottom_images[1]
      ? {
          type: "img",
          src: bottom_images[1].add_image_url,
          className: "small-bottom-left",
        }
      : null,
    // bottom_video_url
    //   ? { type: "video", src: bottom_video_url, className: "large-right" }
    //   : null,
  ].filter(Boolean); // null remove

  return (
    <>
      <div className="main-box">
        <div className="image-video-gallery-wrapper">
          <div className="gallery_head text-center">
            <h3
              className="creativity-heading text-center"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(add_content?.second_heading),
              }}
            />
            <p
              className="creativity-text "
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(add_content?.second_heading_below),
              }}
            />
          </div>

          {/* {arrangedItems.length > 0 ? (
        <div className="image-grid">
          
          {arrangedItems.map((item, iidx) => {
            const stableKey = `gallery-${item.type}-${item.className}-${iidx}`;

            return (
              <div key={stableKey} className={`grid-item ${item.className}`}>
                {{
                  item.type === "video" ? (
                    <video
                      className="hover-video"
                      muted
                      playsInline
                      autoPlay
                      loop
                      preload="auto"
                      width="640"
                      height="360"
                    >
                      <source src={item.src} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <div
                      style={{ cursor: "pointer", width: "100%", height: "100%" }}
                      onClick={() => setSelectedImage(item.src)}
                    >
                      <img
                        src={item.src}
                        alt="Sky47 Facility Image"
                        width="400"
                        height="300"
                        loading="lazy"
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                    </div>
                  )
                }}
                <img
                  src={item.src}
                  alt="Sky47 Facility Image"
                  width="400"
                  height="300"
                  loading="lazy"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            );
          })}
        </div>
      ) : (
        <div className='loader'>
          <img
            src="assets/img/LoaderSky47.gif"
            alt='Loading gallery'
            width="100"
            height="100"
            loading="lazy"
          />
        </div>
      )} */}

        <div className="facility-media-map">
  {/* LEFT - SINGLE IMAGE */}
  <div className="facility-image-column">
    {gallerydata?.image_url && (
      <img
        src={gallerydata?.image_url}
        alt="Sky47 Karakoram-01"
        className="facility-single-image"
        width="650"
        height="500"
      />
    )}
  </div>

  {/* RIGHT - GOOGLE MAP */}
 <div className="facility-map-column">
  <iframe
    title="Sky47 Karakoram-01 Location"
    src={gallerydata?.map_url}
    className="facility-map-iframe"
    loading="eager"
    allowFullScreen
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>

  <div className="facility-map-address">
    <strong>Sky47 Limited | Karakoram-01 Data Center Campus</strong>
    <span>B-15, Silicon Village</span>
    <span>Capital Smart City</span>
    <span>Main Chakri Road</span>
    <span>Rawalpindi, Pakistan</span>
  </div>
</div>
</div>

          <p className="gallery-caption">
            <p
              className="person-details w-100"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(add_content?.second_heading_text),
              }}
            />
            {/* {add_content} */}
          </p>

          {/* Fullscreen Modal ab ImageVideoGallery component ke andar hai */}
          {selectedImage && (
            <div
              className="fullscreen-modal"
              onClick={() => setSelectedImage(null)}
            >
              <span
                className="close-btn"
                onClick={() => setSelectedImage(null)}
              >
                ×
              </span>
              <img
                src={selectedImage}
                alt="Full View"
                className="fullscreen-image"
              />
            </div>
          )}
          <style>{`

          /* =========================
   MOBILE RESPONSIVE FIX
   ========================= */

@media (max-width: 576px) {

  /* Current 10% padding mobile par zyada space kha rahi hai */
  .image-video-gallery-wrapper {
    width: 100%;
    max-width: 100%;
    padding: 0 16px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .facility-media-map {
    width: 100%;
    max-width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    gap: 18px;
    margin-top: 20px;
  }

  .facility-image-column,
  .facility-map-column {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    height: 300px;
    border-radius: 16px;
    overflow: hidden;
    box-sizing: border-box;
  }

  .facility-single-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 16px;
  }

  .facility-map-iframe {
    width: 100%;
    height: 100%;
    min-width: 0;
    display: block;
    border: 0;
    border-radius: 16px;
  }

  /* Address card responsive */
  .facility-map-address {
    position: absolute;

    left: 10px;
    right: 10px;
    bottom: 10px;

    width: auto;
    max-width: none;

    padding: 12px 14px;

    box-sizing: border-box;

    font-size: 12px;
    line-height: 1.45;

    border-radius: 12px;

    background: rgba(255, 255, 255, 0.96);

    overflow-wrap: anywhere;
    word-break: normal;
  }

  .facility-map-address strong {
    font-size: 12px;
    line-height: 1.35;
    margin-bottom: 5px;
  }

  .facility-map-address span {
    font-size: 11px;
    line-height: 1.4;
  }
}
         .facility-media-map {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: stretch;
  margin-top: 30px;
}

.facility-map-column {
  position: relative;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  border-radius: 24px;
}
.facility-map-address {
  position: absolute;
  left: 16px;
  bottom: 16px;
  max-width: 330px;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.18);
  font-size: 13px;
  line-height: 1.5;
  z-index: 2;
}

.facility-map-address strong,
.facility-map-address span {
  display: block;
}

.facility-map-address strong {
  margin-bottom: 4px;
}

.facility-image-column,
.facility-map-column {
  width: 100%;
  height: 500px;
  min-width: 0;
  overflow: hidden;
  border-radius: 24px;
}

.facility-single-image,
.facility-map-iframe {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 24px;
}

.facility-single-image {
  object-fit: cover;
}

.facility-map-iframe {
  border: 0;
}

/* Tablet / Mobile */
@media (max-width: 991px) {
  .facility-media-map {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .facility-image-column,
  .facility-map-column {
    height: 420px;
  }
}

@media (max-width: 576px) {
  .facility-image-column,
  .facility-map-column {
    height: 300px;
    border-radius: 16px;
  }

  .facility-single-image,
  .facility-map-iframe {
    border-radius: 16px;
  }
}


/* Tablet */
@media (max-width: 991px) {
  .facility-media-map {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .facility-gallery-column,
  .facility-map-column {
    height: 420px;
  }
}


/* Mobile */
@media (max-width: 576px) {
  .facility-gallery-column,
  .facility-map-column {
    height: 300px;
  }

  .swiper-container-custom,
  .facility-media-image,
  .facility-map-column,
  .facility-map-iframe {
    border-radius: 16px;
  }
}
      .image-video-gallery-wrapper {
        max-width: 1300px;
        margin: 0 auto; 
        box-sizing: content-box;
        padding: 0 10%;     
      }
      .fullscreen-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
      }
      .fullscreen-image {
        max-width: 90%;
        max-height: 90%;
        border-radius: 10px;
      }
      .close-btn {
        position: absolute;
        top: 20px;
        right: 30px;
        font-size: 40px;
        color: #fff;
        cursor: pointer;
      }
    `}</style>
        </div>
      </div>
    </>
  );
};

// OurFacilitiesTabSection component (Default Export)
const OurFacilitiesTabSection = ({ data, gallerydata }) => {
  if (!data || !Array.isArray(data)) {
    return (
      <div className="loader">
        <img src="assets/img/LoaderSky47.gif" alt="loader image" />
      </div>
    );
  }

  const sortedData = [...data].sort((a, b) => {
    const orderA = a.grid_order_number ?? Number.MAX_SAFE_INTEGER;
    const orderB = b.grid_order_number ?? Number.MAX_SAFE_INTEGER;
    return orderA - orderB;
  });

  return (
    <div className="facilities">
      {/* Gallery Section with gallerydata prop */}
      {/* <ImageVideoGallery gallerydata={gallerydata} /> */}

      <div className="cards-section">
        <div className="cards-container">
          {/* FIX: Use stable unique keys based on grid_heading */}
          {sortedData.map((item, idx) => {
            const stableKey = `facility-${
              item.grid_heading?.replace(/\s+/g, "-") || idx
            }`;

            return (
              <div className="card" key={stableKey}>
                <div className="frame-group-wrapper">
                  <div className="frame-group">
                    <div className="frame-ellipse"></div>
                    <div className="frame-div"></div>
                    <div className="frame-ellipse-2"></div>
                  </div>
                </div>

                {/* FIX: Add width and height attributes to images */}
                {item.grid_icon_url && (
                  <img
                    src={item.grid_icon_url}
                    alt={`${item.grid_heading} icon`}
                    className="card-icon"
                    width="100"
                    height="100"
                    loading="lazy"
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "block",
                      borderRadius: "15px",
                      objectFit: "cover",
                    }}
                  />
                )}
                <div className="card-box">
                  <h3 className="card-heading">{item.grid_heading}</h3>
                  <p className="card-text">{item.grid_paragraph}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Styles */}
      <style>{`
        .fullscreen-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.9);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        .fullscreen-image {
          max-width: 90%;
          max-height: 90%;
          border-radius: 10px;
        }
        .close-btn {
          position: absolute;
          top: 20px;
          right: 30px;
          font-size: 40px;
          color: white;
          cursor: pointer;
        }
        .image-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 10px;
          padding: 10px;
        }
        .grid-item {
          width: 100%;
          height: auto;
          overflow: hidden;
        }
        .grid-item img {
          width: 100%;
          height: auto;
          object-fit: cover;
          display: block;
        }
      `}</style>
    </div>
  );
};

export default OurFacilitiesTabSection;
